import styled from 'styled-components';
import { Typography } from '@thinknet-gmbh/platform-common-ui';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  & > div:last-child {
    display: flex;
  }
`;

export const SupervisorDetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PopoverContentWrapper = styled.div`
  width: 204px;
  word-wrap: break-word;
`;

export const SupervisorRow = styled(Typography)`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 200px;
  height: 100%;
  white-space: nowrap;
`;

export const PopoverEmptyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 9px 12px;
`;
